import { IQ_API_BASE_URL } from "./constants.js";
import { loadPageOnResolve } from "./script.js";

document.addEventListener("DOMContentLoaded", function () {
  const caseStudiesGrid = document.getElementById("case-studies-grid");

  const industryTagsContainer = document.getElementById("industry-tags");

  // Helper function to get URL parameter
  function getUrlParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  // Helper function to update URL parameter
  function updateUrlParameter(name, value) {
    const url = new URL(window.location);
    if (value === "all") {
      url.searchParams.delete(name);
    } else {
      url.searchParams.set(name, value);
    }
    window.history.replaceState({}, "", url);
  }

  const fetchCaseStudies = async () => {
    return fetch(`${IQ_API_BASE_URL}/iqtechmax/case-study`).then(
      async (res) => {
        const data = await res.json();
        const caseStudies = data.caseStudies || [];

        const uniqueIndustries = new Set();
        const uniqueTechStacks = new Set();

        caseStudies.forEach((item) => {
          // Track unique filters
          (item.industries || []).forEach((ind) =>
            uniqueIndustries.add(ind.trim().toLowerCase())
          );
          (item.techstacks || []).forEach((tech) =>
            uniqueTechStacks.add(tech.trim().toLowerCase())
          );
        });

        // Render industry filter buttons (excluding "all")
        uniqueIndustries.forEach((ind) => {
          const btn = document.createElement("button");
          btn.classList.add("filter-tag");
          btn.dataset.industry = ind;
          btn.textContent = capitalize(ind);
          industryTagsContainer.appendChild(btn);
        });

        // Render tech stack (domain) filter buttons (excluding "all")
        uniqueTechStacks.forEach((tech) => {
          const btn = document.createElement("button");
          btn.classList.add("filter-tag");
          btn.dataset.domain = tech;
          btn.textContent = capitalize(tech);
          // domainTagsContainer.appendChild(btn);
        });

        // Render case study cards
        caseStudies.forEach((item, index) => {
          const card = document.createElement("div");
          card.classList.add(
            "case-study-card",
            "tilt-card",
            "radial-hover-card",
            "blur_card"
          );
          const domain = (item.techstacks || [])
            .map((d) => d.toLowerCase().trim())
            .join(",");
          const industries = (item.industries || []).map((ind) =>
            ind.toLowerCase().trim()
          );
          card.setAttribute("data-domain", domain);
          card.setAttribute("data-industry", industries.join(","));
          const domainChips = (item.techstacks || [])
            .map((tag) => {
              uniqueTechStacks.add(tag.toUpperCase());
              return `<span class="chip">${tag.toUpperCase()}</span>`;
            })
            .join(" ");

          const queryParams = new URLSearchParams({
            project: encodeURIComponent(item.clientName || "Case Study"),
            domain: encodeURIComponent((item.techstacks || []).join(", ")),
            problem: encodeURIComponent(item.problemStatement || ""),
            solution: encodeURIComponent(item.ourSolutions || ""),
            impact: encodeURIComponent(item.impactResult || ""),
            id: index,
          });

          const impactHtml = item.impactResult
            ? ` <div class="card-impact"><ul>${item.impactResult
                .split("*")
                .map((x) => x.trim())
                .filter((x) => x)
                .map((x) => `<li>${x}</li>`)
                .join("")}</ul></div>`
            : "";

          card.innerHTML = `
            <div class="radial-hover-effect"></div>
            <div class="card-content">
              <img
                src="${item.clientImageURL}"
                alt="${industries.join(",")}"
              />
              <p class="card-label" id="clientName">${item.clientName || ""}</p>
              
              <p class="card-label id="caseStudyTitle"">${
                item.caseStudyTitle || ""
              }</p>
              
              <div class="domain-indicator">
                ${domainChips}
              </div>
            </div>
            <a class="button-read-more" href="${
              item.caseStudyURL
            }">Read More</a>
          `;
          caseStudiesGrid.appendChild(card);
        });

        setupFiltering();
      }
    );
  };

  function capitalize(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  function setupFiltering() {
    let activeIndustry = (getUrlParameter("industry") || "all").toLowerCase();

    function filterCards() {
      const caseStudyCards = document.querySelectorAll(".case-study-card");
      let visibleCount = 0;

      caseStudyCards.forEach((card) => {
        const cardIndustry = card.dataset.industry;
        const matchIndustry =
          activeIndustry === "all" ||
          cardIndustry.split(",").includes(activeIndustry);

        if (matchIndustry) {
          card.style.display = "grid";
          visibleCount++;
        } else {
          card.style.display = "none";
        }
      });

      if (visibleCount === 0) {
        updateUrlParameter("industry", "all");
        activeIndustry = "all";
        filterCards();

        const noResults = document.querySelector(".no-results");
        if (noResults) noResults.remove();
      }
    }

    function setActiveIndustryButton(industry) {
      industryTagsContainer
        .querySelectorAll(".filter-tag")
        .forEach((btn) => btn.classList.remove("active"));

      const targetButton = industryTagsContainer.querySelector(
        `[data-industry="${industry}"]`
      );
      if (targetButton) {
        targetButton.classList.add("active");
      } else {
        const allButton = industryTagsContainer.querySelector(
          `[data-industry="all"]`
        );
        if (allButton) {
          allButton.classList.add("active");
        }
      }
    }

    industryTagsContainer.addEventListener("click", (e) => {
      if (e.target.classList.contains("filter-tag")) {
        activeIndustry = e.target.dataset.industry;
        console.log(activeIndustry);

        updateUrlParameter("industry", activeIndustry);
        setActiveIndustryButton(activeIndustry);
        filterCards();
      }
    });

    setActiveIndustryButton(activeIndustry);
    filterCards();
  }

  loadPageOnResolve(fetchCaseStudies);
});
